import {useEffect, useState} from "react";
import {Timeline, Tag} from "antd";
import dayjs from "dayjs";
import service from "../../../api/FetchInterceptor";

const statusColors = {
    submitted: "orange",
    waiting_affectation: "orange",
    in_progress: "blue",
    treated: "cyan",
    waiting_validation: "orange",
    validated: "green",
    pre_closed: "gold",
    closed: "default",
    classified: "default",
    sent: "purple",
    withdraw: "green",
    reject: "red",
};

const TimelineDossier = ({code}) => {
    const [steps, setSteps] = useState([]);

    useEffect(() => {
        service({
            method: "GET",
            url: `dossiers/${code}/timeline`,
        }).then((response) => {
            setSteps(response.data);
        });
    }, [code]);

    return (
        <div style={{display: "flex", justifyContent: "center"}}>
            <div style={{maxWidth: 150, width: "100%"}} className="mt-4">
                <Timeline
                    items={steps.map((step) => ({
                        color: step.done ? "green" : "gray",
                        children: (
                            <div>
                                <Tag color={statusColors[step.key] || "default"}>
                                    {step.label}
                                </Tag>
                                <div style={{color: "#8c8c8c", fontSize: 13, marginTop: 4}}>
                                    {step.date ? dayjs(step.date).format("DD/MM/YYYY HH:mm") : "-"}
                                </div>
                            </div>
                        ),
                    }))}
                />
            </div>
        </div>
    );
};

export default TimelineDossier;